import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { UserType } from '@/modules/@common/user/types';

import { type IABNodeType } from '@/modules/@common/helpers/iab';

import { iab } from '@/graphql/services/configuration/resolvers/iab';

type LanguageType = {
  id: string;
  name: string;
};

export type StateType = {
  lastUpdate?: string | null;
  isUserActivated: boolean;
  userData?: UserType | null;
  iab: IABNodeType[];
  videoLangs: {
    id: string;
    name: string;
  }[];
  impersonated: boolean;
};

export const initialState: StateType = {
  lastUpdate: null,
  isUserActivated: false,
  userData: null,
  iab,
  videoLangs: [],
  impersonated: false,
};

export const slice = createSlice({
  name: '@@COMMON/USER',
  initialState,

  reducers: {
    getUserDataAction: (state) => state,
    setUserDataAction: (state, action: PayloadAction<UserType>) => {
      state.userData = action.payload;
    },
    setUserVideoLangsAction: (state, action: PayloadAction<LanguageType[]>) => {
      state.videoLangs = [...action.payload].sort((a, b) => a.name.localeCompare(b.name));
    },
    logOutEventAction: (state, action: PayloadAction<{ logOutPage?: boolean; logoutFrom?: string } | undefined>) => {
      if (action.payload) {
        return state;
      }
      return state;
    },
    cancelImpersonationAction: (state) => state,
  },
});

export const {
  getUserDataAction,
  setUserDataAction,
  setUserVideoLangsAction,
  logOutEventAction,
  cancelImpersonationAction,
} = slice.actions;

export default slice.reducer;
